import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import TypographyHeaderSub from '../../TypographyHeaderSub';
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  content: {
    paddingLeft: 96
  }
}));

const ContentContainer = ({ children }) => {
  const classes = useStyles({})
;
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <TypographyHeaderSub gutterBottom>TESTIMONIES</TypographyHeaderSub>
        <Typography variant="h2">SEE HOW OTHERS</Typography>
        <Typography variant="h2">HAVE TRANSFORMED.</Typography>
        {children}
      </div>
    </div>
  );
};

export default ContentContainer;
